import barba from '@barba/core';
import { InteractiveMap } from './InteractiveMap/InteractiveMap.js';
import { PageTransition } from './managers/PageTransition.js';
import { PageManager } from './managers/PageManager.js';
import { ScrollAnimations } from './components/ScrollAnimations.js';
import { IntroComponent } from './components/IntroComponent.js';
import { FloatingStamps } from "./components/FloatingStamps";
import { ArcChartComponent } from "./components/ArcChartComponent";
import { DigitCounterComponent } from "./components/DigitCounterComponent";
import { TagsGroupComponent } from "./components/TagsGroupComponent";
import { BarChartGroupComponent } from "./components/BarChartGroupComponent";
import { MobileNav } from "./components/MobileNav";
import { ScrollNav } from "./components/ScrollNav";
import { PartnerStamp } from "./components/PartnerStamp";
import { FactionModal } from "./components/FactionModal";
import { detectOperatingSystem } from '../../../js/classes/Helpers';
import { HoverClassOnParent } from '../../../js/classes/Helpers';
import {Newsletter} from "../../../js/classes/Newsletter";
const cities = window.map_cities;

export class GlobalOpportunity {
    constructor() {
        this.setupPageManager();
        this.map = new InteractiveMap();
        this.transitions = new PageTransition(this.map);
        this.currentCity = null;

        this.setupBarba();
    }

    setupPageManager() {
        PageManager.oneTimeFunctions = [
            Newsletter
        ];

        // One-time classes (initialized once when app starts)
        PageManager.oneTimeClasses = [
            MobileNav,
            FactionModal,
        ];

        // Common classes (run on every page)
        PageManager.commonClasses = [
            ScrollNav,
            ScrollAnimations,
            ArcChartComponent,
            BarChartGroupComponent,
            DigitCounterComponent,
            TagsGroupComponent
        ];

        // Classes to dispose on page leave
        PageManager.disposableClasses = [
            ScrollNav,
            ScrollAnimations,
            ArcChartComponent,
            BarChartGroupComponent,
            DigitCounterComponent,
            TagsGroupComponent
        ];

        // Page-specific classes
        PageManager.pageSpecificClasses = {
            home: {
                enter: [],
                leave: []
            },
            city: {
                enter: [IntroComponent, FloatingStamps, PartnerStamp],
                leave: [IntroComponent, FloatingStamps, PartnerStamp]
            }
        };

        // Initialize one-time classes
        PageManager.initApplication();
        // Initialize common classes for first page
        PageManager.initCommonClasses();
    }

    setupBarba() {
        barba.hooks.beforeLeave(({ current }) => {
            // Dispose both common and page-specific classes
            PageManager.disposeClasses();
            PageManager.disposePageClasses(current.namespace);
        });

        barba.hooks.afterLeave(() => {
            // Clean up any remaining animations or states
            PageManager.currentContainer = null;
        });

        barba.hooks.beforeEnter(({ next }) => {
            const namespace = next.namespace;
            // Set the new container before initializing classes
            PageManager.currentContainer = next.container;
            // Initialize classes before content appears
            PageManager.initPageClasses(namespace);
            PageManager.initCommonClasses();
        });

        barba.hooks.afterEnter(() => {
            PageManager.startCommonClasses();
        });

        barba.init({
            debug: true,
            preventRunning: true,
            prevent: ({ el}) => {
                if (el.classList && (el.classList.contains('no-barba') || el.classList.contains('post-edit-link'))) {
                    return true;
                }

                if (el.href) {
                    // Prevent admin links
                    if (el.href.includes('/wp-admin/') || el.href.includes('?action=edit')) {
                        return true;
                    }

                    // Prevent all external links for this project (that don't include global-opportunity)
                    if (!el.href.includes('/global-opportunity')) {
                        return true;
                    }
                }

                return false;
            },
            transitions: [{
                name: 'default-transition',
                sync: true,
                leave: ({ current, next }) => this.transitions.animateContentOut(current.container, next.container),
                enter: ({ next }) => this.transitions.animateContentIn(next.container)
            }],
            views: [{
                namespace: 'city',
                beforeEnter: ({ next }) => {
                    const cityId = next.container.dataset.city;
                    const cityData = cities.find(city => city.id === cityId);
                    if (cityData) {
                        this.map.zoomToCity(cityData);
                        document.getElementById('back-button').classList.remove('hidden');
                    }
                }
            }, {
                namespace: 'home',
                beforeEnter: () => {
                    this.map.resetView();
                    document.getElementById('back-button').classList.add('hidden');
                }
            }]
        });

        document.getElementById('back-button').addEventListener('click', (e) => {
            e.preventDefault();
            barba.go(window.opportunity_page_index);
        });

        const os = detectOperatingSystem();

        if (os === "Windows") {
          document.body.classList.add("win");
        }

        HoverClassOnParent('.footer-nav a', '.footer-nav');
    }
}
